/**
 * Small env-gated logger for the frontend.
 *
 * `debug`/`info`/`warn` are noisy, developer-facing traces and are suppressed
 * unless we're in a Vite dev build or `VITE_DEBUG_LOGGING=true` is set (e.g.
 * to temporarily re-enable them in a deployed environment). `error` is always
 * emitted since it represents an actual failure that's useful to see in the
 * browser console / error reporting regardless of environment.
 */
const isDebugLoggingEnabled =
  import.meta.env.DEV || import.meta.env.VITE_DEBUG_LOGGING === 'true';

const noop = (..._args: unknown[]): void => {};

export const logger = {
  debug: isDebugLoggingEnabled ? console.debug.bind(console) : noop,
  info: isDebugLoggingEnabled ? console.info.bind(console) : noop,
  warn: isDebugLoggingEnabled ? console.warn.bind(console) : noop,
  error: console.error.bind(console),
};
